import { CampaignAccessManagementActions } from "./actions/CampaignAccessManagementActions";
import { DataTag } from "./DataTag";

import { capitalizeWord } from "../../../../helpers";

export const columns = () => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (value: string, record: any) => {
      let color = value === "published" ? "green" : "yellow";
      const label = capitalizeWord(value);
      return <DataTag color={color} label={label} />;
    },
    filters: [
      { text: "Published", value: "published" },
      { text: "Draft", value: "draft" },
    ],
    onFilter: (value: any, record: any) => record.status === value,
  },
  {
    title: "Actions",
    key: "actions",
    render: (value: string, record: any) => {
      return (
        <CampaignAccessManagementActions
          campaignUUID={record.uuid}
          campaignName={record.name}
          users={record.users}
        />
      );
    },
  },
];
